<template>
  <div class="relative flex flex-col justify-center items-center">
    <div class="w-full">
      <report-header
        v-if="report"
        :error.sync="error"
        :has-search-input="true"
        :report="report"
        @update:searchText="getReport"
        @getReport="getReport"
      >
        <template #title>
          user permission report
        </template>
        <template #subtitle>
          analyze the permission level of your users
        </template>
      </report-header>
    </div>
    <div v-if="loadingReport" class="flex justify-center align-center mt-12">
      <loading-icon />
    </div>
    <div v-else class="w-full">
      <sb-custom-table class="sb-table pr-20" :rows="tableRows" :columns="tableColumns" disableTableSort/>
      <div v-if="!loadingReport && tableRows.length < 1" class="no-results-message text-center mt-32">
        no users found
      </div>
      <div v-if="pagesTotal > 1" class="pagination-wrapper flex justify-center items-center mt-10">
        <pagination
          :page.sync="page"
          :pages="pagesTotal"
          :gap="2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SbCustomTable, Pagination, LoadingIcon } from '@springbig/sb-components';
import { reportsAPI } from '../../services/api/reportsAPI';
import ReportHeader from "./ReportHeader.vue";

export default {
  name: "UserPermissionsReport",
  components: {
    SbCustomTable,
    Pagination,
    LoadingIcon,
    ReportHeader
  },
  data() {
    return {
      page: 0,
      report: null,
      tableRows: [],
      loadingReport: false,
      error: {},
      tableColumns: []
    }
  },
  created() {
    this.getReport();
  },
  watch: {
    page() {
      this.getReport();
    }
  },
  computed: {
    pagesTotal(){
      return this.report?.pagination?.total_pages || 1;
    },
  },
  methods: {
    formatReportData() {
      const results = this.report.output_data.results;

      if (results.length > 0) {
        this.tableRows = results.map(result => ({ ...result }));

        if (results.length > 0) {
          const columns = Object.keys(results[0]).map(key => ({
            key,
            value: key.replaceAll('_', ' '),
          }));

          this.tableColumns = columns;
        }
      }
    },
    createNewReport() {
      return reportsAPI.createReport('Reports::UserPermissionsReport');
    },
    fetchExistingReport(searchText) {
      return reportsAPI.getReportById(this.report.id, this.page + 1, { searchText });
    },
     async getReport(newReport, searchText) {
      this.loadingReport = true;
      try {
        const { report, pagination } = !this.report?.id || (this.report.id && newReport) ? await this.createNewReport()
                                                                                         : await this.fetchExistingReport(searchText);
        this.report = { pagination, ...report };
        this.formatReportData();
      } catch(error){
        this.error.message = "error, please refresh or contact support";
      } finally {
        this.loadingReport = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .report-header, .pagination-wrapper {
    // header & pagination should not overflow past the right screen edge like the table
    // so limit width to: screen width - .left-menu width - #content left & right padding
    max-width: calc(100vw - 270px - 6rem);
  }
  @media only screen and (max-width: 1023px) {
    .report-header, .pagination-wrapper {
      min-width: calc(100vw - 2rem);
    }
  }
  .searchbox {
    max-width: 530px;
    &:active, &:focus {
      border-color: #128ff9;
    }
    &::placeholder {
      color: rgba(74, 74, 74, 0.5);
    }
  }
  .no-results-message {
    color: rgba(74, 74, 74, 0.5);
  }
  .sb-table::v-deep {
    width: fit-content;
  }
</style>